<kendo-loader type="pulsing" *ngIf="GetLoadVisible()" >
</kendo-loader>
